let interfaceUrl = `http://127.0.0.1:9100/api`
let socketUrl = `ws://127.0.0.1:23456`

const url = window.location.host
// const url = 'testwaterfront.whwater.com'

if (url === 'testwaterfront.whwater.com') {
  interfaceUrl = `https://testwater.whwater.com/api/`
  socketUrl = `wss://testsocketwater.whwater.com`
}

if (url === 'waterfront.whwater.com') {
  interfaceUrl = `https://water.whwater.com/api/`
  socketUrl = `wss://socketwater.whwater.com`
}

export default {
  interfaceUrl,
  socketUrl
}



// WEBPACK FOOTER //
// ./src/database/env.js